import React, { useState } from "react";
import SEO from "../component/SEO";
import LogoImage from "../images/k-bakery-logo.jpeg";
import { toast } from "react-hot-toast";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_DOMIN}/submitContactForm`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        toast.success("Form submitted successfully!");
        setFormData({ name: "", email: "", message: "" });
      } else {
        toast.error("Error submitting the form. Please try again later.");
      }
    } catch (error) {
      console.error("Contact form submission error:", error);
      toast.error("Server error. Please try again later.");
    }
  };

  return (
    <div className="relative min-h-screen w-full bg-gradient-to-b from-pink-50 via-[#FFE3E0] to-[#FFD6D1] overflow-hidden flex flex-col items-center justify-center p-6 md:p-12">
      <SEO title="Contact Us - K Bakery" description="Get in touch with K Bakery for custom cakes, orders, and queries." />
      {/* Floating Gradient Shapes */}
      <div className="absolute top-10 left-10 w-60 h-60 bg-gradient-to-br from-[#FFB4AB]/50 to-[#E5DEFF]/40 rounded-full float-animation"></div>
      <div
        className="absolute bottom-10 right-10 w-80 h-80 bg-gradient-to-br from-[#E8F4F8]/50 to-[#FFB4AB]/50 rounded-full float-animation"
        style={{ animationDelay: "2s" }}
      ></div>
      <div
        className="absolute top-1/3 right-1/4 w-64 h-64 bg-gradient-to-br from-[#FFD4E3]/60 to-[#E5DEFF]/50 rounded-3xl rotate-12 blur-xl float-animation"
        style={{ animationDelay: "4s" }}
      ></div>
      <div
        className="absolute bottom-1/3 left-1/4 w-52 h-52 bg-gradient-to-br from-[#FFB4AB]/40 to-[#FFD1FF]/30 rounded-2xl blur-lg float-animation"
        style={{ animationDelay: "6s" }}
      ></div>

      {/* Contact Form Container */}
      <div className="relative z-10 max-w-4xl w-full bg-white/50 backdrop-blur-lg rounded-3xl shadow-xl p-8 md:p-12 border border-white/40">
        {/* Heading */}
        <h1 className="text-4xl md:text-5xl font-serif font-normal mb-6 text-center text-black">
          Contact Us
        </h1>
        <p className="text-lg md:text-xl font-serif text-center mb-8 text-[#1E1E1E]">
          Have questions or feedback? We’d love to hear from you!  
          Fill out the form below and we’ll get back to you soon.
        </p>

        {/* Form */}
        <form
          onSubmit={handleSubmit}
          className="max-w-md mx-auto w-full text-left"
        >
          <div className="mb-6">
            <label
              htmlFor="name"
              className="block text-black font-serif text-lg mb-2"
            >
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-3 border border-gray-300 rounded-xl bg-white/80 focus:outline-none focus:ring-2 focus:ring-[#FFB4AB]"
              required
            />
          </div>

          <div className="mb-6">
            <label
              htmlFor="email"
              className="block text-black font-serif text-lg mb-2"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-3 border border-gray-300 rounded-xl bg-white/80 focus:outline-none focus:ring-2 focus:ring-[#FFB4AB]"
              required
            />
          </div>

          <div className="mb-6">
            <label
              htmlFor="message"
              className="block text-black font-serif text-lg mb-2"
            >
              Message
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="4"
              className="w-full p-3 border border-gray-300 rounded-xl bg-white/80 focus:outline-none focus:ring-2 focus:ring-[#FFB4AB]"
              required
            ></textarea>
          </div>

          <div className="flex justify-center">
            <button
              type="submit"
              className="bg-[#FFB4AB] hover:bg-[#ff9b91] transition-all duration-300 text-white font-serif text-lg py-2 px-6 rounded-full shadow-md"
            >
              Submit
            </button>
          </div>
        </form>

        {/* Logo */}
        <div className="flex justify-center mt-10">
          <img
            src={LogoImage}
            alt="Logo"
            className="w-56 md:w-64 h-56 md:h-64 object-contain rounded-full shadow-lg border-4 border-[#FFB4AB]/70 backdrop-blur-sm"
          />
        </div>
      </div>
    </div>
  );
};

export default Contact;
